import React from 'react';
import { Spin } from 'antd';

const ShowSkeleton = ({ tip = 'The content is loading, please wait...' }) => (
	<div style={{
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100vh',
		background: '#fafbfc',
		fontSize: 18
	}}>
		<Spin size="large" tip={tip} style={{ marginBottom: 16 }} />
	</div>
);

export default ShowSkeleton;

